module.exports = __webpack_public_path__ + "static/media/lexus-street-selected.b9df3f30.svg";